import * as React from 'react';
import Box from '@mui/material/Box';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';

const MotionBox = motion(Box);

/**
 * Wraps content and translates it vertically based on scroll progress to create
 * a subtle parallax effect. Disabled when the user prefers reduced motion.
 *
 * @param {number} speed - positive moves slower than scroll (drifts up),
 *                         higher magnitude = stronger effect.
 */
export default function Parallax({ children, speed = 60, sx, ...props }) {
  const reduceMotion = useReducedMotion();
  const ref = React.useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });

  const y = useTransform(scrollYProgress, [0, 1], [speed, -speed]);

  return (
    <MotionBox
      ref={ref}
      style={reduceMotion ? undefined : { y }}
      sx={sx}
      {...props}
    >
      {children}
    </MotionBox>
  );
}
